import { Injectable } from 'angular-ts-decorators';

/**
 * e2e helper, used to provide override values of any setting defined for a tenant or user
 */
@Injectable('settingsOverrides')
export class SettingsOverrides {}
